//@flow
import serverVars from 'server-vars';

export const CUSTOMER_TYPE_TRADE: 'trade' = 'trade';
export const CUSTOMER_TYPE_VIP: 'vip' = 'vip';
export const CUSTOMER_TYPE_CONSUMER: 'consumer' = 'consumer';
export const USER_TOKEN = 'userToken';
export const USER_EMAIL = 'userEmail';
export const USER_TYPE = 'userType';
export const USER_EMAIL_TOKEN = 'userEmailToken';
export const GUEST_USER = 'GUEST_USER';
export const EVER_LOGGED_IN = 'eli';
export const PASSWORD_TOKEN = 'passwordToken';
export const ON_SITE_REGISTRATION = 'onSiteRegistration';

// length of time before local storage values "expire" as session values
// 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
export const PSEUDO_SESSION_EXPIRES_AT = 14400000;
export const DEFAULT_COOKIE_EXPIRATION = 182;
export const VISIT_COUNT = 'visitCount';
export const REG_PROMPT_LIMIT = 3;
export const PSEUDO_SESSION = 'pseudoSessionVisitCount';

export const defaultCookieSettings = {
    domain: serverVars.get('cookieDomain'),
    expires: DEFAULT_COOKIE_EXPIRATION,
    path: '/',
};

export const TRADE_WINDFALL_REFERRAL_KEY = 'windfall';
